module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-LightItalic-7ec68a7c2daf3fb4e22e50510b976d95.otf";